<script setup lang="ts">
import { computed } from 'vue'
import useTailwindColor from 'Common/utils/useTailwindColor'

interface PropTypes {
  color: string
  value: number
  max: number
  title: string
}

const props = defineProps<PropTypes>()
const colorVal = computed<string>(() => {
  return useTailwindColor(props.color)
})
const isDisabled = computed<boolean>(() => {
  return props.value === 0
})
</script>

<template>
  <el-collapse-item :name="props.title" :disabled="isDisabled">
    <template #title>
      <div class="px-4 h-full grid grid-rows-1 grid-cols-2 items-center justify-items-start gap-2 text-lg text-neutral-700">
        <span class="font-medium">{{ props.title }}</span>
        <span class="font-light">{{ props.value }} / {{ props.max }}</span>
      </div>
    </template>
    <div classs="w-full">
      <slot />
    </div>
  </el-collapse-item>
</template>

<style>
#workcard-gallery-accordians .el-collapse-item__header {
  background-color: v-bind(colorVal) !important;
}
</style>
